import React, { createContext, useState } from "react";

const YourGeneratedPodcastContext = createContext();

const YourGeneratedPodcastProvider = ({ children }) => {
  const [currentYourGeneratedPodcast, setCurrentYourGeneratedPodcast] =
    useState([]);

  return (
    <YourGeneratedPodcastContext.Provider
      value={{ currentYourGeneratedPodcast, setCurrentYourGeneratedPodcast }}
    >
      {children}
    </YourGeneratedPodcastContext.Provider>
  );
};

export { YourGeneratedPodcastProvider, YourGeneratedPodcastContext };

// Sample data
// [
//   {
//       "created_at": "2024-09-04 20:28:36",
//       "mins": 10,
//       "topic": "Epistemology",
//       "id": "1fcfa6b3-8343-4095-b606-ea03e9b66cec",
//       "custom_cover_url": "",
//       "custom_cover": false,
//       "level": "Beginner",
//       "user_id": "S3HC3",
//       "status": "COMPLETE",
//       "title": "learn",
//       "audio_file": "audio-e3fad987-f471-401e-ba93-bfcc45607c15.mp3",
//       "created_by": "Test User S3HC3"
//   },
//   {
//       "created_at": "2024-09-04 20:06:16",
//       "mins": 10,
//       "topic": "Epistemology",
//       "id": "61fc1640-abc7-498a-8049-b7abebe37cdb",
//       "custom_cover_url": "",
//       "custom_cover": false,
//       "level": "Beginner",
//       "user_id": "S3HC3",
//       "status": "COMPLETE",
//       "title": "Podcast Title: \"Epistemology: The Dawn on Our Perception of Knowledge\"",
//       "audio_file": "audio-3bf02f56-5a67-402d-bffb-0040ae2ee2bc.mp3",
//       "created_by": "Test User S3HC3"
//   }
// ]
